const state = {
  detailMenu: {},
  sideBarVisible: true,
  windowWidth: 100
};

const mutations = {
  toggleSideBarVisible(state) {
    state.sideBarVisible = !state.sideBarVisible;
  },
  setWindowWidth(state, width) {
    state.windowWidth = width;
  }
};

const getters = {
  isSidebarVisible: (state) => {
    return state.sideBarVisible;
  },
  getWindowWidth: (state) => {
    return state.windowWidth;
  },
  getContentWidth: (state) => {
    if (state.sideBarVisible === true) {
      return (state.windowWidth - 420);
    } else {
      return state.windowWidth;
    }
  }
}

const actions = {
  toggleSideBarVisible(context) {
    context.commit('toggleSideBarVisible');
  },
  setWindowWidth(context, width) {
    context.commit('setWindowWidth', width);
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
